// src/services/holiday.service.js
import { api } from './api';

class HolidayService {
    /**
     * Get all holidays for the current company
     */
    async getAllHolidays(year) {
        try {
            const params = year ? { year } : {};
            const response = await api.get('/api/holidays', { params });
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching holidays:', error);
            // Fallback to localStorage if API fails
            return this.getLocalStorageHolidays();
        }
    }

    /**
     * Get holidays by month
     */
    async getHolidaysByMonth(year, month) {
        try {
            const response = await api.get(`/api/holidays/month/${year}/${month}`);
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching holidays by month:', error);
            return [];
        }
    }

    /**
     * Check if a date is a holiday
     */
    async isHoliday(date) {
        try {
            const response = await api.get(`/api/holidays/check/${date}`);
            return response.data;
        } catch (error) {
            console.error('Error checking holiday:', error);
            return { isHoliday: false, holiday: null };
        }
    }

    /**
     * Fallback: Get holidays from localStorage
     */
    getLocalStorageHolidays() {
        // try {
        //     const stored = localStorage.getItem('hrportal_holidays');
        //     return stored ? JSON.parse(stored) : [];
        // } catch (error) {
        //     console.error('Error loading holidays from localStorage:', error);
        //     return [];
        // }
    }
}

export default new HolidayService();
